import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export default function PointsPurchaseTerms({ showUsage = false, legalLink }: {
  showUsage?: boolean;
  legalLink: ReactNode;
}) {
  const { t } = useTranslation('common');
  return <>
    {showUsage && <p>{t('points.terms.usage')}</p>}
    <p className={`${showUsage ? 'mt-2 ' : ''}font-bold text-gray-700`}>{t('points.terms.expiration')}</p>
    <p className="mt-2">{t('points.terms.paymentMethod')}</p>
    {legalLink}
  </>;
}
